const BoardDocLogsAdapter = data => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'companies.title': i?.title,
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default BoardDocLogsAdapter;
